<div class="price" *ngIf="price !== 0; else zeroPrice">
  <span class="price__main">
    <app-price [price]="price">
      <span i18n="@@From" *ngIf="isMinimalPrice" priceBefore>from</span>
    </app-price>
  </span>

  <ng-container *ngIf="oldPrice">
    <div class="price__old">
      <app-price [price]="oldPrice"></app-price>
    </div>
    <div class="price__discount">-{{ discount }}%</div>
  </ng-container>
</div>

<ng-template class="price" #zeroPrice>
  <span i18n="@@Free">Free</span>
</ng-template>
